<template>
  <div class="account account-settings">
    <navigation-header :backRoute="homeRoute" />
    <credentials-data />
    <footer>
      <div class="card card--rounded payments">
        <h2>{{ $t('account.payments.title') }}</h2>
        <payment-data />
      </div>
      <Kim class="card card--rounded" color="#421D40" mood="happy" />
    </footer>
  </div>
</template>

<script>
import { HOME_ROUTE } from '@/router/utils'
import accountComponents from '@/components/async/account'
import { mapState } from 'vuex'

export default {
  name: 'home',
  components: {
    ...accountComponents
  },
  computed: {
    ...mapState({
      subscriptionStatus: state => state.user.subscription.subscriptionStatus,
      subscriptionPlatform: state => state.user.subscription.platform
    }),
    homeRoute() {
      return HOME_ROUTE
    },
    canCancel() {
      if (this.subscriptionStatus === 'RENEW_CANCELLED') {
        return false
      }

      return this.subscriptionPlatform !== 'APP_STORE' && this.subscriptionPlatform !== 'GOOGLE_PLAY'
    }
  }
}
</script>

<style lang="scss" scoped>
.account {
  padding: 0 2rem;
  position: relative;
  background: {
    image: url('~@/assets/backgrounds/account.svg');
    position: 50vw -60vh;
    size: auto 120vh;
    color: white;
    repeat: no-repeat;
  }
  footer {
    width: 100%;
    padding-right: 2rem;
    padding-bottom: 5rem;
    box-sizing: content-box;
    background: {
      image: url('~@/assets/backgrounds/lightning2.svg');
      color: white;
      repeat: no-repeat;
      position: right bottom;
    };
    @media ($screen-md) {
      display: flex;
    }
    > * {
      margin-top: 1rem;
      @media ($screen-md) {
        margin: 0
      }
    }

    .payments {
      width: 100%;
      h2 {
        margin: 0;
        color: #27C2F2
      }
      @media ($screen-md) {
        width: calc(60% - 1rem);
        position: relative;
        float: left;
      }
    }
    .kim {
      z-index: 2;
      position: relative;
      width: 100%;
      @media ($screen-md) {
        margin-left: 1rem;
        float: right;
        width: 40%;
      }
    }
  }
}
</style>
